import { Avatar } from "../../atoms/avatar";
import { platformProps } from "../../lib";
import { Box } from "../../primitives";
import { useChatBubbleContext } from "./chat-bubble-context";
import type { ChatBubbleAvatarProps } from "./types";

/**
 * Wraps the `Avatar` atom for sender/receiver bubbles. Suppressed for the
 * `system` variant — system messages render centered without an avatar gutter.
 */
export const ChatBubbleAvatar = ({
  src,
  name,
  initials,
  className,
  testID,
}: ChatBubbleAvatarProps) => {
  const { variant } = useChatBubbleContext();

  if (variant === "system") return null;

  return (
    <Box className={className} {...platformProps({ testID, slot: "chat-bubble-avatar" })}>
      <Avatar
        size="sm"
        variant="image"
        src={src}
        name={name}
        initials={initials}
        fallbackVariant="initialGrey"
      />
    </Box>
  );
};

ChatBubbleAvatar.displayName = "ChatBubble.Avatar";
